import {handleSpinButton} from "./spin";
import {freeSpinStore, store} from "../store";
import {pixiComponents} from "../index";

export const handleKeyUp = (event) => {
    if (store.isSessionExpired ) {
        return;
    }

    if (event.code === 'Space') {
        const {spinBtn, stopSpinBtn, stopAutoSpinBtn} = pixiComponents.cpItems;
        const isSpinBtnsVisible = spinBtn.visible || stopSpinBtn.visible || stopAutoSpinBtn.visible;

        if ((freeSpinStore.freeSpin && freeSpinStore.freeSpin.id )|| !isSpinBtnsVisible) {
            return;
        }
        handleSpinButton();
    }
}
